<template>
  <transition-group
    mode="out-in"
    name="fade"
  >
    <div
      v-for="(alert, index) in alerts"
      :key="index"
      class="alert"
      :class="{
        'alert-success': alert.status === 'success',
        'alert-danger': alert.status === 'error',
      }"
      role="alert"
    >
      {{ I18n.t(`employees.auctions_catalogs.internet_orders.${alert.message}`, { count: formatPrice(alert.value) }) }}
    </div>
  </transition-group>
</template>

<script>
  import { mapState } from 'vuex';
  import { formatNumber } from '@/shared/helpers';

  export default {
    name: 'Alerts',
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    computed: {
      ...mapState(['alerts']),
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/orders/alerts.vue?21bbeafc